import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReceived = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15,
	height: 8,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "#6b7a8a",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", { d: "M14.17 0 7.696 6.445 4.73 4.082 4 4.99l3.377 2.69.411.319 6.792-6.764.42-.409z" }), /* @__PURE__ */ _jsx("path", { d: "m.73 4.082 2.967 2.363.647-.644.926.724L3.788 8l-.41-.318L0 4.99zM10.17 0l.83.827-.42.41-3.882 3.865-.926-.723z" })]
	})
});
export default SvgReceived;
